module.exports = __webpack_public_path__ + "img/lalamove.ada85912.png";